import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

function CnxHeader({ panelSx, sessionReady, authenticatedPointer, accountId }) {
  const identityLabel =
    String(authenticatedPointer || "").trim() ||
    String(accountId || "").trim() ||
    "";

  return (
    <Box sx={{ ...panelSx, py: 2.25 }}>
      <Typography className="cnx-exp-eyebrow" variant="body2">
        CNX Chat by Entzy
      </Typography>
      <Typography
        variant="h4"
        sx={{
          mt: 1,
          fontWeight: 700,
          color: "#f4f6ff",
        }}
      >
        {sessionReady ? "Encrypted chat" : "Portable chat activation"}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          mt: 1,
          color: "rgba(197,204,225,0.76)",
        }}
      >
        {sessionReady
          ? "Provider-backed CNX session is active."
          : "Activate once, then come back to the same chat state through the provider session store."}
      </Typography>
      {sessionReady && identityLabel ? (
        <Box
          sx={{
            mt: 1.5,
            display: "inline-flex",
            alignItems: "center",
            px: 1.4,
            py: 0.7,
            borderRadius: 999,
            border: "1px solid rgba(255,255,255,0.08)",
            background: "rgba(255,255,255,0.03)",
          }}
        >
          <Typography variant="caption" sx={{ color: "rgba(197,204,225,0.68)" }}>
            Signed in as
          </Typography>
          <Typography
            variant="body2"
            sx={{ ml: 0.9, fontWeight: 700, color: "#ffcfad" }}
          >
            {identityLabel}
          </Typography>
        </Box>
      ) : null}
    </Box>
  );
}

export default CnxHeader;
